import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';

Component('tr-project-table-view-toolbar', {
  mixins: [eventListenerMixin],

  properties: {
    totalRows: {
      type: Number,
      default: 0,
      observer: 'totalRowsChanged',
    },
    selectedIds: {
      type: Array,
      default: [],
      observer: 'selectedIdsChanged',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.listenTo(this.querySelector('.close-btn'), {
      click: this.handleCloseBtnClick.bind(this),
    });

    $(this).on('ajax:beforeSend', 'a.operation', this.handleOperationClick.bind(this));
  },

  handleCloseBtnClick() {
    this.selectedIds = [];
    this.namespacedTrigger('close');
  },

  totalRowsChanged() {
    this.querySelector('.total').textContent = this.totalRows;
  },

  handleOperationClick(event, xhr, settings) {
    // eslint-disable-next-line no-param-reassign
    settings.data += `&${$.param({
      todos_batch_task: {
        action: event.currentTarget.dataset.action,
        todo_ids: this.selectedIds,
      },
    })}`;
  },

  selectedIdsChanged() {
    this.active = this.selectedIds.length > 0;
    this.querySelector('.count').textContent = this.selectedIds.length;
  },

  removeSelectedId(id) {
    const selectedIds = this.selectedIds.slice(0);
    const selectedIndex = selectedIds.findIndex(selected => selected === id);
    if (selectedIndex === -1) return;

    selectedIds.splice(selectedIndex, 1);
    this.selectedIds = selectedIds;
    this.totalRows -= 1;
  },

  disconnected() {
    this.stopListening();
  },
});
